import { render } from "./YesNoBadge.vue?vue&type=template&id=3030c1c9"
import script from "./YesNoBadge.vue?vue&type=script&lang=js"
export * from "./YesNoBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__